<template>
    <div class="loginBg">
        <div class="particles-js-box">
            <div id="particles-js">
                <div class="login">
                    <div class="login-top">
                        <img :src="logoSrc" class="logoImg" alt="" srcset="">
                    </div>
                    <el-tabs v-model="activeName" stretch @tab-click="handleClick" :class="['login-select',activeName=='1'? 'ceping1':'']">
                        <el-tab-pane label=" " name="1" v-if="activeName=='1'">
                            <div class="login-center clearfix">
                                <div class="login-center-img"><img :src="nameUrl"/></div>
                                <div class="login-center-input">
                                    <input type="text" v-model="account" @change="searchEnterFun(account,1)" maxlength="11" name="" value="" placeholder="请输入手机号" onfocus="this.placeholder=''" onblur="this.placeholder='请输入手机号'"/>
                                    <div class="login-center-input-text">手机号</div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                            <div class="login-center clearfix" style="margin-bottom:4px">
                                <div class="login-center-img"><img :src="pwdUrl"/></div>
                                <div class="login-center-input" style="position: relative">
                                    <input type="password" v-model="pwd" class="login-center-input-password" name="" value="" placeholder="请输入密码" onfocus="this.placeholder=''" onblur="this.placeholder='请输入密码'"/>
                                    <div class="login-center-input-text">密码</div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label=" " name="2" v-if="activeName=='2'">
                            <div class="login-center clearfix">
                                <div class="login-center-img"><img :src="nameUrl"/></div>
                                <div class="login-center-input">
                                    <input type="text" name="" v-model="account"  maxlength="18" value="" placeholder="请输入证件号" onfocus="this.placeholder=''" onblur="this.placeholder='请输入证件号'"/>
                                    <div class="login-center-input-text">证件号</div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                            <div class="login-center clearfix" style="margin-bottom:4px">
                                <div class="login-center-img"><img :src="pwdUrl"/></div>
                                <div class="login-center-input" style="position: relative">
                                    <input type="password" v-model="pwd" class="login-center-input-password" name="" value="" placeholder="请输入密码" onfocus="this.placeholder=''" onblur="this.placeholder='请输入密码'"/>
                                    <div class="login-center-input-text">密码</div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div class="login-error">{{errorMsg}}</div>
                    <!-- <div class="registered-button" @click="goRegistered" v-if="activeName==1">
                        注册
                    </div> -->
                    <div type="primary" class="login-button" @click="getLogin">
                        登录
                    </div>
                    <div v-if="activeName==1" class="wangjiClass">
                        <el-button type="text" class="forGetBtn" @click="goRegistered">新户注册</el-button>
                        <el-divider direction="vertical"></el-divider>
                        <el-button type="text" class="forGetBtn" @click="forgetPwd">忘记密码</el-button>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog :title=" inputType=='zhuce'? ' 注 册 ':' 忘记密码 ' " class="regIsteredBox" :modal="false" :show-close="false" :close-on-click-modal="false" center :visible.sync="isShowRegistered" :close-on-press-escape="false">
            <el-form :model="form" ref="form" :rules='rules'>
                <el-form-item prop="zc_account">
                    <el-input v-model.number="form.zc_account" @input="searchEnterFun(form.zc_account,2)" maxlength="11" autocomplete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item prop="smsCode" class="pr">
                    <el-input placeholder="短信验证码" :disabled="regDia"  v-model="form.smsCode"></el-input>
                    <button type="button" @click="getCode" :disabled="getcodeText!='获取验证码'||regDia" class="code-btn">{{getcodeText}}</button>
                </el-form-item>

                <el-form-item prop="zc_pwd">
                    <el-input type="password" v-model="form.zc_pwd" :disabled="regDia" autocomplete="off" placeholder="请您设置密码" auto-complete="new-password"></el-input>
                </el-form-item>
                <el-form-item prop="zc_pwdPass">
                    <el-input type="password" v-model="form.zc_pwdPass" :disabled="regDia" autocomplete="off" placeholder="请您再次输入密码" auto-complete="new-password"></el-input>
                </el-form-item>

                <div class="zcClassMsg" :style="{color:(zc_err=='注册成功！'||zc_err=='密码重置成功！'? 'green':'red')}">{{zc_err}}</div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="offDialogReg">返 回</el-button>
                <el-button type="primary" @click="qiGoReg()" :disabled="regDia">提 交</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import particlesJs from "particles.js";
    import particlesConfig from "@/assets/js/particles.json";
    import Global from '../api/global'
    export default {
            data() {
                var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.form.zc_pwdPass !== '') {
                        this.$refs.form.validateField('zc_pwdPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.form.zc_pwd) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                nameUrl:require('../../static/images/name.png'),
                pwdUrl:require('../../static/images/password.png'),
                logoSrc:require('../../static/images/guoyin-logo.png'),
                getcodeText:'获取验证码',
                activeName: '2',
                account:'',//15810204065
                smsCode:'',
                pwd:'',
                errorMsg:'',
                isShowRegistered: false,
                form: {
                    smsCode:'',
                    zc_account:'',
                    zc_pwd:'',
                    zc_pwdPass:'',
                },
                rules:{
                    zc_account:[{required: true, message: '请输入手机号', trigger: 'blur'}],
                    smsCode:[{required: true, message: '请输入验证码', trigger: 'blur'}],
                    zc_pwd: [
                        { validator: validatePass, trigger: 'blur' }
                    ],
                    zc_pwdPass: [
                        { validator: validatePass2, trigger: 'blur' }
                    ],
                },
                zc_err:'',
                lenter:null,
                regDia:true,
                timeTer1:null,
                timeTer2:null,
                inputType:'',
                rNGet:'',
            }
        },
        components:{},
        watch: {
            '$route.params.roadName'(now,old){
                this.roadNameSet()
            }
        },
        beforeDestroy() {
            if(this.timeTer1) {
                clearTimeout(this.timeTer1);
                this.timeTer1 = null;
            }
            if(this.timeTer2) {
                clearTimeout(this.timeTer2);
                this.timeTer2 = null;
            }
            if(this.lenter) {
                clearTimeout(this.lenter);
                this.lenter = null;
            }
            document.onkeydown = null
        },
        computed:{},
        created(){},
        mounted(){
            this.addUdeskCn();
            // this.init();
            this.roadNameSet()

            let that = this
            document.onkeydown = function(e) {
                var ev = (typeof e!= 'undefined') ? window.event : e
                if(ev.keyCode == 13) {
                    that.getLogin()
                }
            }
        },
        methods:{
            roadNameSet(){
                let roadNameVal = 'guoyin'
                if(this.$route.params.roadName && Object.keys(this.veinQuest).includes(this.$route.params.roadName)){
                    roadNameVal = this.$route.params.roadName
                }
                window.localStorage.setItem('roadName',roadNameVal)
                this.rNGet = roadNameVal
                if(this.veinQuest[this.rNGet].logo)
                this.logoSrc = require('../../static/images/'+ this.veinQuest[this.rNGet].logo)

                if(localStorage.getItem('roadName')&&localStorage.getItem('roadName')=='Dr'){
                    // document.title = '中国音乐学院博士研究生招生网'
                    document.title = '中国音乐学院研究生招生考试网'
                }else{
                    document.title = '中国音乐学院硕士研究生招生复试报名网'
                }
            },
            init() {
                particlesJS("particles-js", particlesConfig);
                document.body.style.overflow = "hidden";
            },
            addUdeskCn(){
                (function(a,h,c,b,f,g){a["UdeskApiObject"]=f;a[f]=a[f]||function(){(a[f].d=a[f].d||[]).push(arguments)};g=h.createElement(c);g.async=1;g.src=b;c=h.getElementsByTagName(c)[0];c.parentNode.insertBefore(g,c)})
                (window,document,"script","https://wap-sz.aitestgo.com/showOnly/udeskApi.js?ut=1709691420931","ud");
                ud({
                    "code": "2f0k97h2",
                    "link": "https://ata.s2.udesk.cn/im_client_nocdn/?web_plugin_id=61482",
                    "onlineText": "客服",
                    "offlineText": "留言",
                    "pos_flag": "hrm",
                });
                this.$nextTick(()=>{
                    let kFu = document.getElementById('udesk_container')
                    if(kFu)
                    kFu.style.display = "inherit"
                })
            },
            handleClick(tab, event) {
                // console.log(tab, event);
            },
            getCode(){
                let that = this;
                if(!that.form.zc_account){that.zc_err='手机号为空！';return}
                that.$axios.post('/sms/getCode',{
                    phone:that.form.zc_account,
                    uid:0
                }, res => {
                    let v = res.data;
                    if (res.data.code == 0) {
                        that.zc_err = v.msg
                        let time = 120;
                        that.lenter = setInterval(() => {
                            that.getcodeText = time+' s'
                            if(time<=0) {
                                clearInterval(that.lenter)
                                that.getcodeText = '获取验证码'
                            }
                            time--;
                        }, 1000);

                        that.timeTer2 = setTimeout(()=>{
                           that.zc_err = '' 
                        },2000)
                    }else{
                        if(v.msg)
                            that.zc_err = v.msg;
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            getLogin(){
                let that = this
                that.errorMsg = ''
                if(!that.account){that.errorMsg='证件号为空！';return}
                if(!that.pwd){that.errorMsg='密码为空！';return}
                that.$axios.post('/v1/account/login',{
                    account:that.account.trim(),
                    pwd:that.$md5(that.pwd).toLowerCase(),
                    smsCode:that.smsCode,
                    uid:0
                }, res => {
                    that.timeTer1 = setTimeout(function(){
                        if (res.data.code == 0) {
                            that.$nextTick(()=>{
                                let nn = +new Date();
                                window.localStorage.setItem('secretKey-web',that.$base64.encode(res.data.data.secretKey));
                                localStorage.setItem('userToken-web',that.$base64.encode(res.data.data.token));
                                localStorage.setItem('tokenExpiryTime-web',that.$base64.encode((res.data.data.tokenExpiryTime)*1000+nn));
                                window.localStorage.setItem('uid-web',that.$base64.encode(res.data.data.id));
                                window.localStorage.setItem('usermag-web',that.$base64.encode(JSON.stringify({
                                    account:res.data.data.account,
                                    name:res.data.data.name,
                                })));
                                that.calculateNowTime(res.data.data.nowTimeVal)
                                Global.loginUid = res.data.data.id

                                that.$router.push({
                                    path: '/myExamList'
                                })
                            })
                        }else{
                            if(res.data.msg)
                                that.errorMsg = res.data.msg;
                            else
                                that.errorMsg = '请求错误';
                        }
                    },50)
                })
            },
            calculateNowTime(nowTimeVal){
                let nTime = Date.parse(new Date(nowTimeVal.replace(/-/g, "/")));
                let pcTime = new Date().getTime();
                let poorTime = nTime - pcTime;
                let poorVal = 0;
                if(Math.abs(poorTime)>=60000){
                    poorVal = poorTime
                }
                localStorage.setItem('poorVal',poorVal);
            },
            searchEnterFun(val,t){
                if(!val){this.zc_err = '';this.regDia = true;return}
                if(!(/^1[1356789]\d{9}$/.test(val))){
                    this.cTyMsg(t,"手机号格式错误")
                    this.regDia = true
                    return
                }else{
                    this.detectionPhone(val,t)
                }
            },
            detectionPhone(ph,t){
                let that = this
                if(!(/^1[1356789]\d{9}$/.test(ph))){
                    that.cTyMsg(t,"手机号格式错误")
                    return
                }
                that.$axios.post('/account/phone/isRegist',{
                    phone:ph,
                    uid:0
                }, res => {
                    if (res.data.code == 0) {
                        if(res.data.data.flag){
                            if(t!=1){
                                if(that.inputType=='zhuce') that.zc_err = "手机号已注册"
                                if(that.inputType=='wangji') {that.zc_err = "手机号已注册";that.regDia = false}
                            }else{
                                that.cTyMsg(t,"")
                            }
                        }else{
                            if(t!=1){
                                if(that.inputType=='zhuce') {that.regDia = false;that.cTyMsg(t,"手机号未注册")}
                                if(that.inputType=='wangji') {that.cTyMsg(t,"手机号未注册")}
                            }else{
                                that.cTyMsg(t,"手机号未注册")
                            }
                        }
                    }else{
                        if(res.data.msg)
                            that.cTyMsg(t,res.data.msg)
                        else
                            that.$message.error('请求错误');
                    }
                })
            },
            cTyMsg(t,msg){
                if(t==1) this.errorMsg = msg
                if(t==2) this.zc_err = msg
                let that = this
                // let tiemss = setTimeout(()=>{
                //     that.errorMsg = ''
                //     that.zc_err   = ''
                //     clearTimeout(tiemss);
                // },2000)
            },
            goRegistered(){
                this.inputType = 'zhuce'
                this.isShowRegistered = true
            },
            forgetPwd(){
                this.inputType = 'wangji'
                this.isShowRegistered = true
            },
            qiGoReg(){
                if(this.inputType=='zhuce')this.goSumitZc()
                if(this.inputType=='wangji')this.goSumitWj()
            },
            goSumitZc(){
                let that = this
                that.$refs['form'].validate((valid) => {
                    if (valid) {
                        that.$axios.post('/account/regist',{
                            account:that.form.zc_account,
                            pwd:that.$md5(that.form.zc_pwdPass).toLowerCase(),
                            smsCode:that.form.smsCode,
                            uid:0
                        }, res => {
                            if (res.data.code == 0) {
                                that.zc_err = '注册成功！';
                                that.clearDatas()
                            }else{
                                if(res.data.msg)
                                    that.zc_err = res.data.msg;
                                else
                                    that.$message.error('请求错误');
                            }
                        })
                    }
                })
            },
            goSumitWj(){
                let that = this
                that.$refs['form'].validate((valid) => {
                    if (valid) {
                        that.$axios.post('/account/updatePwdByPhone',{
                            phone:that.form.zc_account,
                            pwd:that.$md5(that.form.zc_pwdPass).toLowerCase(),
                            smsCode:that.form.smsCode,
                            uid:0
                        }, res => {
                            if (res.data.code == 0) {
                                that.zc_err = '密码重置成功！';
                                that.clearDatas()
                            }else{
                                if(res.data.msg)
                                    that.zc_err = res.data.msg;
                                else
                                    that.$message.error('请求错误');
                            }
                        })
                    }
                })
            },
            offDialogReg(){
                this.isShowRegistered = false
                this.zc_err = ''
                this.clearDatas()
            },
            clearDatas(){
                this.form.smsCode = ''
                this.form.zc_account = ''
                this.form.zc_pwd = ''
                this.form.zc_pwdPass = ''
                clearInterval(this.lenter)
                this.getcodeText = '获取验证码'
                this.$refs['form'].resetFields();
                this.regDia = true
                this.inputType = ''
            }
        }
    }
</script>
<style scoped lang="less">
    .loginBg{
        height: 100%;
        width: 100%;
        background-image: url('../../static/images/bg.jpg');
        background-position: 50% 50%;
        background-size: cover;
        background-repeat: no-repeat;
        margin-left: auto;
        margin-right: auto;
        .particles-js-box{
            position:fixed;
            width: 100%;
            height: 100%;
            top:0;
            left:0;
            z-index:1;
            #particles-js{
                width: 100%;
                height: 100%;
            }
        }
    }
    @keyframes login-small{
        0%{transform: scale(1);-moz-transform: scale(1);	/* Firefox 4 */-webkit-transform: scale(1);	/* Safari å’Œ Chrome */-o-transform: scale(1);	/* Opera */-ms-transform:scale(1); 	/* IE 9 */
        }100%{transform: scale(0.2);-moz-transform: scale(0.1);	/* Firefox 4 */-webkit-transform: scale(0.2);	/* Safari å’Œ Chrome */-o-transform: scale(0.1);	/* Opera */-ms-transform:scale(0.1); 	/* IE 9 */}
    }
    .login{z-index: 2;position:absolute;width: 350px;border-radius: 5px;height: 500px;background: white;box-shadow: 0px 0px 5px #333333;top: 50%;left: 50%;margin-top: -250px;margin-left: -175px;transition: all 1s;-moz-transition: all 1s;	/* Firefox 4 */-webkit-transition: all 1s;	/* Safari å’Œ Chrome */-o-transition: all 1s;	/* Opera */}
    .login-top{height: 216px;font-size: 24px;margin-top: 30px;box-sizing: border-box;color: #333333;margin-bottom: 5px;text-align: center;}
    .login-top img.logoImg{max-width: 98%;max-height: 100%;}
    .login-select{width:100%;margin-bottom: 10px;}
    .login-error{height: 20px;font-size: 16px;color: red;}
    .login-center{width: 100%;box-sizing: border-box;padding: 0 40px;margin-bottom: 25px;clear: both;margin-top: 15px;}
    .login-center-img{width: 20px;height: 20px;float: left;margin-top: 5px;}
    .login-center-img>img{width: 100%;}
    .login-center-input{float: left;width: 230px;margin-left: 15px;height: 30px;position: relative;}
    .login-center-input input{z-index: 2;transition: all 0.5s;padding-left: 10px;color: #333333;width: 100%;height: 30px;border: 0;border-bottom: 1px solid #cccccc;border-top: 1px solid #ffffff;border-left: 1px solid #ffffff;border-right: 1px solid #ffffff;box-sizing: border-box;outline: none;position: relative;background-color: transparent !important;color: #000;}
    .login-center-input input:focus{border: 1px solid dodgerblue;}
    .login-center-getCode{font-size: 12px;position: absolute;right: 0;bottom: 0;z-index: 9;width: 92px;}
    .login-center-input-text{background: white;padding: 0 5px;position: absolute;z-index: 0;opacity: 0;height: 20px;top: 50%;margin-top: -10px;font-size: 14px;left: 5px;color: dodgerblue;line-height: 20px;transition: all 0.5s;-moz-transition: all 0.5s;	/* Firefox 4 */-webkit-transition: all 0.5s;	/* Safari å’Œ Chrome */-o-transition: all 0.5s;	/* Opera */}
    .login-center-input input:focus~.login-center-input-text{top: 0;z-index: 3;opacity: 1;margin-top: -15px;}
    .login.active{-webkit-animation: login-small 0.8s ; animation: login-small 0.8s ;animation-fill-mode:forwards;-webkit-animation-fill-mode:forwards}
    .login-button{cursor: pointer;width: 250px;text-align: center;height: 40px;line-height: 40px;background-color: #409EFF;border-radius: 5px;margin: 0 auto;margin-top: 5px;color: white;}
    .registered-button{cursor: pointer;width:62.5px;float: left;text-align: center;height: 38px;line-height: 38px;border-radius: 5px;margin: 0 auto;margin-top: 5px;margin-left: 50px;border: 1px solid #dcdfe6;color: #606266;}
    .teShu{width: 172.5px !important;float: right;margin-right: 50px;}
    .wangjiClass{cursor: pointer;width:100%;float: left;text-align: right;height: 30px;line-height: 30px;box-sizing: border-box;padding-right: 50px;}
    .login-center-input-code:-webkit-autofill,
    .login-center-input-password:-webkit-autofill,
    .login-center-input input:-webkit-autofill{  
        -webkit-text-fill-color: #000 !important;  
        -webkit-box-shadow: 0 0 0px 1000px transparent  inset !important;  
        box-shadow: 0 0 0px 1000px transparent  inset !important;  
        background-color:transparent;  
        background-image: none;
        transition: background-color 50000s ease-in-out 0s;  
    }
    .pr {
        position: relative;
    }
    .code-btn {
        width: 100px;
        height: 20px;
        position: absolute;
        top: 10px;
        right: 5px;
        z-index: 222;
        color: #ef8466;
        font-size: 14px;
        border: none;
        border-left: 1px solid #bababa;
        padding-left: 10px;
        background-color: transparent;
        cursor: pointer;
        pointer-events:  auto;
        z-index: 99999999;
    }
    .zcClassMsg{
        font-size: 17px;
        text-align: center;
        margin-top: 5px;
        color: red;
    }
</style>
<style>
    .login-select .el-tabs__nav-wrap{
        width: 180px;
        margin: auto;
    }
    .login-select .el-tabs__active-bar {
        background-color: transparent !important;
        margin-bottom: -2px;
    }
    .login-select .el-tabs__nav-wrap::after{
        height:0px;
    }
    .login-select .el-tabs__item {
        font-size: 13px;
    }
    .login-select .el-tabs__header{margin: 0 !important;}
    .regIsteredBox .el-dialog{
        width: 350px !important;
        height: 500px !important;
    }
    .regIsteredBox .el-dialog{
        display: flex;
        flex-direction: column;
        margin:0 !important;
        position:absolute;
        top:50%;
        left:50%;
        transform:translate(-50%,-50%);
        /*height:600px;*/
        border-radius: 5px !important;
        max-height:calc(100% - 30px);
        max-width:calc(100% - 30px);
    }
    .regIsteredBox .el-dialog .el-dialog__body{
        flex:1;
        overflow: auto;
        padding: 15px 25px 20px !important;
    }
    .regIsteredBox .el-dialog .el-dialog__header span{
        color: #333333 !important;
        font-size: 24px;
    }
    .regIsteredBox .el-dialog .el-dialog__header{
        margin-top: 35px;
        box-sizing: border-box;
        margin-bottom: 0px;
        text-align: center;
        background: #fff;
    }
    .regIsteredBox .el-dialog--center .el-dialog__footer{
        padding: 10px 20px 45px;
    }
    .regIsteredBox .el-input__inner::placeholder {
        color: #747574 !important;
    }
    .forGetBtn{
        padding: 11px 0;
    }
    .ceping1 .el-tabs__header.is-top{
        height: 25px;
    }
    .ceping1 .el-tabs__header.is-top .el-tabs__item{
        height: 25px;
        line-height: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/login.vue